<template>
  <el-dialog
    title="物品信息（必填）"
    width="716px"
    :visible="visible"
    @close="handleClose"
  >
    <section class="common list">
      <section
        v-for="(goods, index) in typeArr"
        :class="['goods', { active: goods === current }]"
        :key="index"
        @click="handlePick(goods)"
      >
        {{ goods }}
      </section>
    </section>
    <section class="history">
      <section class="history-header" v-if="initHistory.length">
        <span class="history-header-title">历史自定义物品类型</span>
        <span class="history-header-action" @click.stop="handleAction">{{
          isEdit ? '完成' : '删除'
        }}</span>
      </section>
      <section class="history-content list">
        <section
          v-for="(goods, index) in history"
          :class="[
            'goods',
            { active: goods.item_note === current, waiting: isEdit },
          ]"
          :key="index"
          @click="handlePick(goods.item_note, true)"
        >
          {{ goods.item_note }}
          <template v-if="isEdit">
            <img
              v-if="goods.item_note === current"
              class="el-icon-close goods-close"
              src="../assets/images/goods_picker_close_3.png"
              @click.stop="handleRemove(goods.id)"
            />
            <img
              v-else
              class="el-icon-close goods-close"
              src="../assets/images/goods_picker_close_2.png"
              @click.stop="handleRemove(goods.id)"
            />
          </template>
        </section>
      </section>
      <el-form :rules="customRule" :model="form" ref="form">
        <el-form-item prop="inputValue">
          <el-input
            class="custom"
            v-model.trim="form.inputValue"
            placeholder="自定义物品类型（不超过6个字）"
            @input="handleInput"
          />
        </el-form-item>
      </el-form>
    </section>

    <el-footer>
    <div class="weight">
      <div class="left">
        <div style="font-weight:bold;color:#222222">物品重量</div>
        <div style="font-size: 12px;color:#999999">实际重量以快递员揽件核实为准</div>        
      </div>
      <div class="right">
        <el-input-number v-model="weight" :precision="2" :step="1" :max="99.90" :min="0" size="small"></el-input-number> KG
      </div>
    </div>
      <el-button class="submit" type="primary" @click.stop="handleSubmit"
        >保存</el-button
      >
    </el-footer>
  </el-dialog>
</template>

<script>
import home from '@/api/home'
import myLocalStorage from '@/util/crypto.js'
// export const typeArr = [
//   '食品',
//   '文件票件',
//   '电子产品',
//   '服装鞋帽',
//   '美妆日化',
//   '珠宝饰品',
//   '玩具乐器',
//   '易碎品',
//   '工艺品',
// ]
let typeArr = [
    '食品',
    '文件票件',
    '电子产品',
    '服装鞋帽',
    '美妆日化',
    '珠宝饰品',
    '玩具乐器',
    '易碎品',
    '工艺品',
  ]
export default {
  name: 'GoodsPicker',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 是否需要在初始化的时候回执父组件，避免在编辑订单时对初始值造成干扰
    initReceipt: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    visible(v) {
      this.$refs.form?.clearValidate?.()
      this.history = this.initHistory
      this.removeIds = []
    },
  },
  data() {
    return {
      typeArr,
      preCurrent: null,
      current: null,
      customRule: {
        inputValue: [
          {
            validator(rule, value, callback) {
              if (!value) {
                callback('请填写物品类型')
              } else if (
                /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi.test(
                  value
                )
              ) {
                callback('不支持表情符')
              } else if (value.length > 6) {
                callback('不超过6个字')
              } else callback()
            },
            trigger: 'blur',
          },
        ],
      },
      weight:0.1,
      form: {
        inputValue: null,
      },
      initHistory: [] /** 初始历史记录 */,
      history: [] /** 历史记录 */,
      removeIds: [],
      isEdit: false /** 历史记录操作状态 */,
    }
  },
  beforeMount() {
    this.getGoodsTypes()
    this.handleLoadPreType()
  },
  methods: {
    // 获取上一次的物品类型
    handleLoadPreType() {
      if (!this.initReceipt) {
        this.handleLoadHistory()
        return
      }
      let cacheType = null
      try {
        const preOrder = JSON.parse(myLocalStorage.getItem('preSave'))
        cacheType = preOrder.typeContent
      } finally {
        home
          .getCurrentMailGoodsType()
          .then((res) => {
            if (res.success && res.body.code === 200) {
              this.current = this.preCurrent = res.body.data
              this.$emit('picked', {goods:this.current,weight:this.weight}, true)
            } else {
              if (cacheType) {
                this.current = this.preCurrent = cacheType
                this.$emit('picked',{goods:cacheTypet,weight:this.weight}, true)
              }
            }
            this.handleLoadHistory()
          })
          .catch(() => {
            this.current = this.preCurrent = cacheType
            this.$emit('picked',{goods:cacheTypet,weight:this.weight}, true)
            this.handleLoadHistory()
          })
      }
    },
    // 获取最近九次的历史记录
    handleLoadHistory() {
      const errCallback = () => {
        if (![...typeArr].includes(this.current)) {
          this.form.inputValue = this.current
        }
      }
      home
        .getCustomMailGoodsTypeRecords()
        .then((res) => {
          if (res.success && res.body.code === 200) {
            this.initHistory = this.history = [...(res.body.data ?? [])]
            this.handleResetInputValue()
          } else {
            errCallback()
          }
        })
        .catch(() => {
          errCallback()
        })
    },
    // 选中
    handlePick(goods, custom = false) {
      if (this.isEdit && custom) return
      this.current = goods
      this.preCurrent = goods
      this.$emit('picked', {goods:this.current,weight:this.weight})
    },
    // 编辑/保存
    handleAction() {
      if (!this.isEdit) {
        this.isEdit = !this.isEdit
      } else {
        this.handleSubmitRemove()
      }
    },
    // 记录删除操作
    handleRemove(id) {
      this.history = this.history.filter((i) => i.id !== id)
      this.removeIds = [...this.removeIds, id]
      this.handleResetInputValue()
    },
    // 删除历史记录项
    handleSubmitRemove() {
      if (!this.removeIds.length) {
        this.isEdit = false
        return
      }
      home
        .removeCustomMailGoodsTypeRecord(this.removeIds)
        .then((res) => {
          if (res.success && res.body.code === 200) {
            this.handleLoadHistory()
            this.isEdit = false
          } else {
            this.$message.error(res.body.message)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    handleInput(v) {
      this.current = v.trim()
    },
    handleSubmit() {
      if(this.isEdit){
        this.handleAction()
      }
      if (
        [...this.history.map((i) => i.item_note), ...typeArr].includes(
          this.current
        )
      ) {
        this.$emit('picked', {goods:this.current,weight:this.weight})
        return
      }
      this.$refs.form?.validate((valid) => {
        if (valid) {
          this.isEdit = false
          this.preCurrent = this.current
          this.handleResetInputValue()
          this.$emit('picked', {goods:this.current,weight:this.weight})
          this.onSaved()
        }
      })
    },
    async onSaved() {
      await home.createCustomMailGoodsTypeRecord({ item_note: this.current.trim() })
      this.handleLoadHistory()
    },
    handleClose() {
      this.isEdit = false
      this.current = this.preCurrent
      this.handleResetInputValue()
      this.$emit('close')
    },
    handleResetInputValue() {
      this.form.inputValue = ![
        ...typeArr,
        ...this.history.map((i) => i.item_note),
      ].includes(this.current)
        // ? this.current
        ? null
        : null
    },
    handlePublicSetCurrent(value) {
      this.current = value
      this.handleLoadHistory()
    },
    getGoodsTypes(){
      home.getTypeArr(this).then(res=>{
          let arr = res.data.data.item_types
          arr = arr.map(obj=> {
            return obj.item_type_name
          })
          typeArr = arr
          this.typeArr = arr
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
goods-size = calc((100% - 16px * 4) / 5)
.history
  &-header
    margin 14px 0 20px;
    display: flex;
    justify-content: space-between;
    &-title {
      font-size: 14px;
      font-weight: 500;
      color: #303133;
    }
    &-action {
      cursor: pointer;
      color: #409EF2;
    }
.list
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
.goods
  position: relative;
  height: 32px;
  width: goods-size;
  flex: 0 0 goods-size;
  margin-right: 16px;
  margin-bottom: 16px
  line-height: 32px;
  text-align: center;
  border: 1px solid #ECECEC;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  color: #303133;
  &.active
  &:not(.waiting):hover
    border-color: #409EF2;
    color: #409EF2;
    background-color: #F2F9FF;

  &:nth-child(5n)
    margin-right: unset;
  &-close {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -50%);
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
.submit
  width: 98px;
.custom
  width: 100%;
  margin-top: 14px;
</style>

<style lang="stylus" scoped>
/deep/.el-dialog__header
  border: 1px solid #DCDFE6;
/deep/.el-dialog__title
  font-weight: bold;
/deep/.el-dialog__close.el-icon-close
  font-size: 24px;
/deep/.el-dialog__body
  padding: 30px 36px;
.el-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: unset;
}
.weight{
  display: flex;
  justify-content: flex-start;
  align-items:center
}
.weight .right{
  margin-left:20px
}
</style>
